import { baseUrl } from '../../../network'

// export const inventoryTurnoverRateUrl = (companyId:number)=>baseUrl + `/api/company/${companyId}/inventory/turnover`

export const inventoryTurnover = (companyId:number)=>baseUrl + `/api/company/${companyId}/warehouse/stats/replacement`